import translating from './translate.json';
import GlobalContext from '../../contexts';
import { useContext } from 'react';

const fields = () => {
  const { organizationsList, productsList, categoriesList } =
    useContext(GlobalContext);

  return [
    {
      name: 'parentId',
      label: translating.productBasicName,
      required: true,
      type: 'select',
      options: productsList?.filter((p) => p.parentId === 0)
    },
    {
      name: 'organizationId',
      label: translating.orgRelated,
      subField: 'organization',
      required: true,
      type: 'select',
      options: organizationsList
    },
    {
      name: 'name',
      label: translating.name,
      required: true
    },
    {
      name: 'categoryId',
      label: translating.category,
      required: true,
      type: 'select',
      options: categoriesList
    },

    {
      name: 'price',
      label: translating.productPrice,
      type: 'number',
      width: '87px',
      required: true,
      pattern: /^[+]?\d+([.]\d+)?$/
    },
    {
      name: 'discountType',
      label: translating.discountType,
      required: true,
      default: 'אחוז',
      type: 'radio',
      options: [
        { id: 'אחוז', name: 'אחוז' },
        { id: 'מחיר קבוע', name: 'מחיר קבוע' }
      ]
    },
    {
      name: 'discountMaxValue',
      required: true,
      label: translating.discountMaxValue,
      type: 'number',
      pattern: /^[+]?\d+([.]\d+)?$/
    },
    {
      name: 'numberOfAppointments',
      label: translating.numberOfAppointments,
      type: 'number',
      pattern: /^[+]?\d+([.]\d+)?$/
    },
    {
      name: 'isActive',
      label: translating.status,
      type: 'switch',
      default: true
    }
  ];
};

export default fields;
